import { render, staticRenderFns } from "./PaymentLayout.vue?vue&type=template&id=2897a872&scoped=true"
import script from "./PaymentLayout.vue?vue&type=script&lang=js"
export * from "./PaymentLayout.vue?vue&type=script&lang=js"
import style0 from "./PaymentLayout.vue?vue&type=style&index=0&id=2897a872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897a872",
  null
  
)

export default component.exports